import chunk from 'lodash/chunk'

export const alphabet = [...Array(26)].map((_, y) =>
  String.fromCharCode(y + 65)
)
export const chunkedAlphabet = chunk(alphabet, 3).map((c) => c.join(''))
